import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EquisButtonModule } from '@tn-equis/core/components/button';
import { EquisCardModule } from '@tn-equis/core/components/card';
import { EquisTextfieldModule } from '@tn-equis/core/components/textfield';
import { EquisControlMessageModule } from '@tn-equis/core/components/control-message';
import { EquisDividerModule } from '@tn-equis/core/components/divider';
import { EquisStickerAnimationModule } from '@tn-equis/core/components/sticker-animation';
import { EquisLoadingModule } from '@tn-equis/core/components/loading';
import { EquisServicesModule } from '@tn-equis/core/services';
import { EquisListModule } from '@tn-equis/core/components/list';
import { EquisIconContainerModule } from '@tn-equis/core/components/icon-container';
import { EquisDropdownModule } from '@tn-equis/core/components/dropdown';
import { EquisActionCardModule } from '@tn-equis/core/components/action-card';

@NgModule({
  imports: [
    CommonModule,
    EquisDividerModule.forRoot(),
    EquisButtonModule.forRoot(),
    EquisCardModule.forRoot(),
    EquisTextfieldModule.forRoot(),
    EquisControlMessageModule.forRoot(),
    EquisStickerAnimationModule.forRoot(),
    EquisLoadingModule.forRoot(),
    EquisListModule.forRoot(),
    EquisIconContainerModule.forRoot(),
    EquisActionCardModule.forRoot(),
    EquisDropdownModule.forRoot(),
    EquisServicesModule,
  ],
  exports: [
    EquisDividerModule,
    EquisButtonModule,
    EquisServicesModule,
    EquisCardModule,
    EquisTextfieldModule,
    EquisControlMessageModule,
    EquisStickerAnimationModule,
    EquisLoadingModule,
    EquisIconContainerModule,
    EquisActionCardModule,
    EquisDropdownModule,
    EquisListModule,
  ],
  providers: [],
  declarations: [],
})
export class EquisModule {
  static forRoot(): ModuleWithProviders<EquisModule> {
    return {
      ngModule: EquisModule,
    };
  }
}
